import { Table, TimelineItem } from '@yaradigitallabs/ahua-react';
import { Colors } from '../../../../../public/GlobalTokens';
import {
  formatTimestamp,
  getStatusIcon,
  getStatusText,
} from '../../utils/tags.helpers';

const ModalStatusTable = ({ execution, index }) => {
  return (
    <Table
      key={execution.id || index}
      css={{ width: '100%' }}
      style={{
        backgroundColor:
          index % 2 !== 0 ? Colors.colorType.grayscale.lightest : '',
      }}
    >
      <thead>
        <Table.Row>
          <Table.SortHead style={{ padding: '8px' }}>
            Execution ID
          </Table.SortHead>
          <Table.SortHead style={{ padding: '8px' }}>Status</Table.SortHead>
          <Table.SortHead style={{ padding: '8px' }}>Timestamp</Table.SortHead>
        </Table.Row>
      </thead>
      <tbody>
        <Table.Row key={execution.id || index}>
          <Table.Cell style={{ padding: '8px' }}>
            {execution.id || 'N/A'}
          </Table.Cell>
          <Table.Cell style={{ padding: '8px' }}>
            <div className="flex items-center gap-2">
              <TimelineItem.IconButton
                colorConcept={getStatusIcon(execution.status).colorConcept}
                icon={getStatusIcon(execution.status).icon}
                size="xs"
                title={getStatusIcon(execution.status).title}
              />
              <span
                style={{ color: getStatusText(execution.status).statusColor }}
              >
                {getStatusText(execution.status).statusText}
              </span>
            </div>
          </Table.Cell>
          <Table.Cell style={{ padding: '8px' }}>
            <span className="text-sm">
              {formatTimestamp(execution.execution_date)}
            </span>
          </Table.Cell>
        </Table.Row>
        {execution.status === 'error' && (
          <Table.Row>
            <Table.Cell colSpan={3} style={{ padding: '8px' }}>
              <div className="max-h-[110px] overflow-auto">
                <b>Error Message:</b> {execution.error_url}
              </div>
            </Table.Cell>
          </Table.Row>
        )}
      </tbody>
    </Table>
  );
};

export default ModalStatusTable;
